import InputButton from './InputButton';

export default InputButton;
